///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, inject } from '@angular/core';
import { AbstractDialogManager } from '../../../dialog-manager/abstract-dialog-manager';
import { map, Observable } from 'rxjs';
import { CustomerDialogComponent } from './customer-dialog.component';
import { GtthCustomerService } from '../../../services/customer/customer.service';
import { SuiCustomerDTO } from '../../../generated/shared-sui-types.model';

@Component({
    selector: 'winde-edit-customer-dialog-wrapper-component',
    template: '',
    standalone: false
})
export class EditCustomerDialogWrapperComponent extends AbstractDialogManager<SuiCustomerDTO, CustomerDialogComponent> {
    private readonly customerService = inject(GtthCustomerService);

    constructor() {
        super(CustomerDialogComponent);
        this.openDialog();
    }

    preparingBaseConfig(): void {
        this.baseConfig.width = '800px';
        this.baseConfig.position = { top: '30px' };
        this.baseConfig.data.id = +this.activatedRoute.snapshot.paramMap.get('id') || null;
    }

    override findById(id: number): Observable<SuiCustomerDTO> {
        return this.customerService.find(id).pipe(map((customer) => new SuiCustomerDTO(customer)));
    }
}
